import { LOCALE_TO_BCP47, toBcp47 } from './locale-bcp47'

/**
 * Points `<html lang>` at the locale actually on screen.
 *
 * The static shell ships `lang="en"`. Left stale, browsers trust that
 * declaration over the visible text and offer to translate an already
 * translated page — it also drives screen-reader pronunciation, hyphenation
 * and `:lang()`. App locale codes are not BCP 47, so the value has to be
 * mapped before it reaches the attribute.
 *
 * Tolerates junk because it sits on the locale-change path: a bad value must
 * degrade to the i18next fallback, never throw and take the caller down.
 */
export function syncDocumentLanguage(locale: string | undefined | null): void {
  document.documentElement.lang = toBcp47(locale) ?? LOCALE_TO_BCP47.enUs
}
